import React from 'react'
import NotFound from '../notfound'

const NotFoundDe = () => {
    return <NotFound languageCode="de" />
}

export default NotFoundDe
